module.exports = window.__federationLoadRemote("moduleSocial");